import React from 'react';
import EmptyState from './EmptyState';

// Página 404 compartida de VLS (auditoría de UI 2026-10-20, Lote 0, arreglo
// #10): reemplaza el NotFound de la plantilla (en inglés, con bg-blue-500) y
// los 404 copiados de otra app (QB decía "Volver al cierre del día").
//
// Va junto con EmptyState.jsx en la misma carpeta (sync-ui.sh --only=boundary
// copia los dos).
//
// ─── Migración (mecánica) ────────────────────────────────────────────────
//   ANTES:  <Route path="*" element={<NotFound />} />
//   DESPUÉS:
//     import NoEncontrado from './components/ui/NoEncontrado';
//     <Route path="*" element={<NoEncontrado />} />
//   Con react-router, para no recargar la página al volver:
//     const navigate = useNavigate();
//     <NoEncontrado onInicio={() => navigate('/')} />
//   Borrar después el NotFound.jsx propio de la app.
//
// Props:
//   titulo        'No encontramos esta página' por defecto.
//   descripcion   'La dirección no existe o cambió. …' por defecto.
//   inicioHref    destino de "Volver al inicio" ('/' por defecto).
//   inicioLabel   'Volver al inicio' por defecto.
//   onInicio      si viene, "Volver al inicio" es un botón que lo llama (para
//                 navegar con el router) en vez de un enlace.
//   hubUrl        destino de "Volver al hub" (https://vlscr.net; null lo quita).
//   pantallaCompleta  alto mínimo de pantalla menos el encabezado (true).
// Sin dependencias; colores por var(--color-*) con respaldo.

const C = {
  border: 'var(--color-border, #E7E5E4)',
  card: 'var(--color-card, #FFFFFF)',
  fg: 'var(--color-foreground, #1C1917)',
  primary: 'var(--color-primary, #0F7A3D)',
  primaryFg: 'var(--color-primary-foreground, #FFFFFF)',
};

const BASE = 'inline-flex items-center justify-center text-sm font-medium rounded-lg focus:outline-none focus-visible:ring-2 focus-visible:ring-ring';
const PRINCIPAL = { minHeight: 44, padding: '0 16px', background: C.primary, color: C.primaryFg, border: 0, textDecoration: 'none' };
const SECUNDARIO = { minHeight: 44, padding: '0 16px', background: C.card, color: C.fg, border: `1px solid ${C.border}`, textDecoration: 'none' };

function Brujula() {
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
      strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <circle cx="12" cy="12" r="10" />
      <polygon points="16.24 7.76 14.12 14.12 7.76 16.24 9.88 9.88 16.24 7.76" />
    </svg>
  );
}

export default function NoEncontrado({
  titulo = 'No encontramos esta página',
  descripcion = 'La dirección no existe o cambió. Revise el enlace o vuelva al inicio.',
  inicioHref = '/', inicioLabel = 'Volver al inicio', onInicio,
  hubUrl = 'https://vlscr.net', pantallaCompleta = true,
}) {
  const inicio = onInicio
    ? <button type="button" onClick={() => onInicio()} className={`${BASE} hover:opacity-90`} style={PRINCIPAL}>{inicioLabel}</button>
    : <a href={inicioHref} className={`${BASE} hover:opacity-90`} style={PRINCIPAL}>{inicioLabel}</a>;
  return (
    <div
      data-vls-no-encontrado=""
      className="flex items-center justify-center"
      style={{ minHeight: pantallaCompleta ? 'calc(100vh - 64px)' : undefined, padding: '32px 16px' }}
    >
      <div style={{ width: '100%', maxWidth: 480 }}>
        <EmptyState
          framed
          icon={<Brujula />}
          title={titulo}
          description={descripcion}
          action={(
            <div className="flex flex-wrap items-center justify-center" style={{ gap: 8 }}>
              {inicio}
              {hubUrl && <a href={hubUrl} className={`${BASE} hover:bg-black/5`} style={SECUNDARIO}>Volver al hub</a>}
            </div>
          )}
        />
      </div>
    </div>
  );
}
